import classNames from 'classnames';
import { type ReactNode, useId } from 'react';
import Typography from '@alltrails/core/components/Typography';
import styles from './UpsellFeatureList.module.scss';
import UpsellFeatureRow, { type UpsellFeature, type UpsellFeatureVariant } from './UpsellFeatureRow';

type Props = {
  label?: ReactNode;
  rows: UpsellFeature[];
  // 'compact' matches the plans-page board (72px thumbnails, smaller label/body). 'default' keeps the generic upsell modal sizing.
  variant?: UpsellFeatureVariant;
};

// Shared feature list used by the generic upsell modals and the plans page (via Plus/PeakMembershipIncludes).
export default function UpsellFeatureList({ label, rows, variant = 'default' }: Props) {
  const headingId = useId();
  const isCompact = variant === 'compact';

  return (
    <section aria-labelledby={label ? headingId : undefined} className={classNames(styles.container, { [styles.containerCompact]: isCompact })}>
      {label && (
        <Typography className={styles.sectionLabel} color="tertiary" component="p" id={headingId} variant={isCompact ? 'text100bold' : 'text200'}>
          {label}
        </Typography>
      )}
      <ul className={styles.list}>
        {rows.map((row, index) => (
          <UpsellFeatureRow key={index} body={row.body} src={row.src} title={row.title} variant={variant} />
        ))}
      </ul>
    </section>
  );
}
